import { Theme } from "@mui/material/styles";

declare module "@mui/material/Paper" {
    interface PaperPropsVariantOverrides {
        caution: true;
        contained: true;
        containedDark: true;
        containedLight: true;
        outlined: true;
        main: true;
        mainTable: true;
    }
}

export default function Paper(theme: Theme) {
    return {
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            variants: [
                {
                    props: { variant: "main" },
                    style: {
                        padding: theme.spacing(4, 3),
                        [theme.breakpoints.down("sm")]: {
                            padding: theme.spacing(2),
                            margin: theme.spacing(0, -2),
                            borderRadius: 0,
                        },
                    },
                },
                {
                    props: { variant: "mainTable" },
                    style: {
                        // padding: theme.spacing(4, 3),
                        [theme.breakpoints.down("sm")]: {
                            // padding: theme.spacing(2),
                            margin: theme.spacing(0, -2),
                            borderRadius: 0,
                        },
                    },
                },
                {
                    props: { variant: "outlined" },
                    style: { borderColor: theme.palette.grey[500_12] },
                },
                {
                    props: { variant: "contained" },
                    style: {
                        backgroundColor: theme.palette.background.neutral,
                        boxShadow: "none !important",
                    },
                },
                {
                    props: { variant: "containedDark" },
                    style: {
                        backgroundColor: theme.palette.background.neutralDark,
                        boxShadow: "none !important",
                    },
                },
                {
                    props: { variant: "containedLight" },
                    style: {
                        backgroundColor: theme.palette.background.neutralLight,
                        boxShadow: "none !important",
                    },
                },
                {
                    props: { variant: "caution" },
                    style: {
                        backgroundColor: theme.palette.background.caution,
                        boxShadow: "none !important",
                    },
                },
                {
                    props: { elevation: 16 },
                    style: {
                        [theme.breakpoints.down("sm")]: {
                            borderRadius: 0,
                        },
                    },
                },
            ],
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                },
            },
        },
    };
}
